import React from 'react';
import {DeleteBtn, DropDownBtn, EditBtn, ChevronExpandBtn, ChevronCollapseBtn, UngroupBtn} from 'components/lib/buttons/IconButtons';
import { PrimaryButton } from 'components/lib/buttons/Button';
// import { ScrollToElement } from "utils/SmoothScroll";
import styles from 'styles/components/lib/tables/dnd/dndRow.css';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';

const BUTTONS = {
  Delete: DeleteBtn,
  Edit: EditBtn,
  Expand: ChevronExpandBtn,
  Collapse: ChevronCollapseBtn,
  Ungroup: UngroupBtn
  // AddTo: ChevronExpandBtn
};


const DnDActionButtons = ({ buckets, col, isExpanded, isNewBucket,
      isNewBucketCreation, isEditing, isOtherBucketEditing,
      isSelectedGroup, row, style, ...props}) => {

    let buttons = col.actions(row).map((a,key) => {
      if (a === 'Delete' && !isEditing) return null;
      if (a === 'Ungroup' && (isNewBucket || (isOtherBucketEditing && !isEditing))) return null;
      if (a === 'AddTo' && isExpanded === undefined) return null;
      if (a === 'Edit' && isOtherBucketEditing) return null;

	    if (isNewBucket) return null;
      if (a !== 'AddTo') {
	      if ( isNewBucket ) return null;
        let ActionButton = BUTTONS[a];
        if (a === 'Expand' && isExpanded) ActionButton = BUTTONS['Collapse'];
        let func = `onClick${a}`;
        return <ActionButton key={key}
                             isExpanded={isExpanded}
                             animate="true"
                             disabled={a === 'Edit' &&
                                   (isEditing || isNewBucketCreation || isOtherBucketEditing)}
                             className="dndIconButton"
                             onClick={props[func]} />
      } else {
        let bucketKeys = Object.keys(buckets);
        let menuItems = bucketKeys.map((elem, key) => {
          return <MenuItem key={key}
                           className={isNewBucketCreation || isOtherBucketEditing ?
                             styles.menuItemDisabled : styles.menuItem}
                           disabled={isNewBucketCreation || isOtherBucketEditing}
                           onClick={e => addTo(e, elem)}
                           primaryText={buckets[elem].name.toUpperCase()}
                           value={elem} />
        });

        let addTo = (e, value) => {
          if(value === "New Group") {
            if (!isOtherBucketEditing) {
              props.onAddToNewBucket(e, {key:null, index:0});
	            // ScrollToElement('#dailyReportBuilder');
            }
          }
          else {
	          // ScrollToElement(`#bucket${value}`, -200);
	          props.onAddToBucket( value, true );
          }
        }

        let isDisabled = !props.isSelected || props.isDragged ||
	                        props.isUnactive || props.isOtherBucketEditing;
        return (
          <IconMenu key="addToMenu"
                    iconButtonElement={
                      <DropDownBtn
                        disabled={ isDisabled }
                        label={`Add ${isSelectedGroup ? 'All ' : ''}To`}
                        style={{
                          fontSize: '12px',
                          fontWeight: '600',
                          backgroundColor: `${isDisabled ? '#CCCCCC' : '#3395FF'}`,
                          width: '100px',
                          height: '30px'}} />
                    }>
            { bucketKeys.length > 0 &&
              <div key={"groupsContainer"}>
                <MenuItem className={ styles.group }
                          disabled={ true }
                          value="Header"
                          primaryText="Your Ticket Groups"/>
                < Divider key={ 0 }/>
                { menuItems }
                <Divider key={ 1 }/>
              </div>
            }
            <MenuItem key="buttonContianer"
                      className={styles.newGroup }
                      onClick={e => addTo(e, "New Group")}
                      value="New Group"
                      children={
                        <PrimaryButton key="newGroup"
                                       disabled={props.isOtherBucketEditing}
                                       label="New Group"
                                       style={{
                                         flexDirection: 'column',
                                         width: '190px',
                                         height: '40px',
                                         fontSize: '12px',
                                         marginTop: '10px'}}
                                       {...props} /> }/>
          </IconMenu> );
    }
  });
  return (
    <li className={styles[col.name]} style={style}>
      { buttons }
    </li>
  );
};




export default DnDActionButtons



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDActionButtons.js